//ErrorPage.tsx
import { ErrorPage as Errorpage } from 'quil';
import {  Box } from '@mui/material';
export default function ErrorPage(){

    return (
     <Box><Errorpage/></Box>
    );
}

